export default "__VITE_ASSET__D95b6yDb__"